import React from "react"
import PropTypes from "prop-types"
import Select from "react-select"
import { collabSelectStyles } from "../../../components/DashboardComponents/CollaboratorSearchSelect"
import { ICONS } from "../../../constants/icons"

/**
 * City multi-select matching Invite Collaborator search UI
 * (`project-collab-modal__search` + chip tags).
 */
const StaffCityMultiSelect = ({
  id = "staff-city-multi-select",
  label = "Select City",
  options = [],
  value = [],
  onChange,
  onBlur,
  error = null,
  placeholder = "Search cities...",
  isLoading = false,
  disabled = false,
}) => {
  const selected = options.filter(option =>
    (value || []).includes(option.value),
  )
  const hasError = Boolean(error)

  return (
    <div className="project-collab-modal project-collab-modal--invite admin-staff-city-select">
      <div className="project-collab-modal__field">
        {label ? (
          <label className="project-collab-modal__label" htmlFor={id}>
            {label}
          </label>
        ) : null}
        <div
          className={`project-collab-modal__search${
            hasError ? " project-collab-modal__search--error" : ""
          }`}
        >
          <img src={ICONS.messageSearchCollab} alt="" />
          <Select
            inputId={id}
            className="project-collab-modal__user-select"
            classNamePrefix="project-collab-modal-user"
            options={options}
            value={selected}
            onChange={next =>
              onChange((next || []).map(option => option.value))
            }
            onBlur={onBlur}
            isMulti
            isSearchable
            isClearable={false}
            isDisabled={disabled}
            isLoading={isLoading}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            placeholder={placeholder}
            noOptionsMessage={() =>
              options.length === 0 ? "No cities available" : "No cities found"
            }
            components={{
              IndicatorSeparator: null,
              DropdownIndicator: null,
            }}
            styles={collabSelectStyles(hasError)}
            menuPortalTarget={
              typeof document !== "undefined" ? document.body : null
            }
            menuPosition="fixed"
            filterOption={(option, rawInput) => {
              const query = String(rawInput || "")
                .trim()
                .toLowerCase()
              if (!query) return true
              return String(option.label || "")
                .toLowerCase()
                .includes(query)
            }}
            aria-label={label || "Select cities"}
          />
        </div>
        {hasError ? (
          <span className="project-collab-modal__error">{error}</span>
        ) : null}
      </div>
    </div>
  )
}

StaffCityMultiSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  placeholder: PropTypes.string,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
}

StaffCityMultiSelect.defaultProps = {
  id: "staff-city-multi-select",
  label: "Select City",
  options: [],
  value: [],
  onBlur: undefined,
  error: null,
  placeholder: "Search cities...",
  isLoading: false,
  disabled: false,
}

export default StaffCityMultiSelect
